import React, {Component} from 'react';
//import TestData from './data'
import TableFilter from '../TableFilter'
import CommesseTable from './CommesseTable'
import CommesseReportList from './CommesseReportList'
import CommessaStatoSelect from './CommessaStatoSelect'
import CommesseListTypeButton from './CommesseListTypeButton'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';

class CommesseList extends Component {

    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.storeInstance = createInstance();

        this.state = this.getDefaultState();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeCommessaStato = this.onChangeCommessaStato.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.loadData = this.loadData.bind(this)
        this.onDeleteCommessa = this.onDeleteCommessa.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)

        this.instance = createInstance();
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {}, // Inizialmente ordinamento standard
            // orderInfo: {
            //     columnName: 'priorita',
            //     direction: 'A',
            //     data: [{field: 'priorita', direction: 'A', },{field: 'nome', direction: 'A', }]},
            filterInfo: {isChiusa: false, isArchiviata: false},
            _loading: false,
            error: null,
            listViewType: 'l',
        };
    }


    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += 'Nome o codice contenente: ' + this.state.filterInfo.keyword;
        }
        if (this.state.filterInfo.isChiusa){
            msg += ' Prestazioni concluse: SI';
        }
        else {
            msg += ' Prestazioni concluse: NO';
        }
        if (this.state.filterInfo.isArchiviata){
            msg += ' Archiviate: SI';
        }
        else {
            msg += ' Archiviate: NO';
        }
        return  msg.trim();
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);}
        );
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('commesselist', this , () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }))
        {}
        else{
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
        // Segnalati comportamenti anomali. #2 BUG

        // if (this.instance && this.instance.restore('commesselist', this , () => {
        //
        //         if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
        //         {
        //             if (this.props.location.state.from.pathname.includes("commesse/edit"))
        //             {
        //                 let commessa = this.props.location.state.item;
        //                 let items = this.state.items.map((cit) => {
        //                     if (cit.idCommessa === commessa.idCommessa)
        //                     {
        //                         return commessa;
        //                     }
        //                     return cit;
        //                 });
        //                 this.setState({items: items});
        //             }
        //             else if (this.props.location.state.from.pathname.includes("commesse/new"))
        //             {
        //                 let commessa = this.props.location.state.item;
        //                 let items = [commessa];
        //                 this.setState({items: items.concat(this.state.items)});
        //             }
        //
        //         }
        //         else {
        //             this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        //         }
        //
        //     }) === null){
        //     this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
        // }
        // this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo,
        //     ()=>{
        //
        //         if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
        //         {
        //             if (this.props.location.state.from.pathname.includes("commesse/edit"))
        //             {
        //                 let commessa = this.props.location.state.item;
        //                 let items = this.state.items.map((cit) => {
        //                     if (cit.idCommessa === commessa.idCommessa)
        //                     {
        //                         return commessa;
        //                     }
        //                     return cit;
        //                 });
        //                 this.setState({items: items});
        //             }
        //             else if (this.props.location.state.from.pathname.includes("commesse/new"))
        //             {
        //                 let commessa = this.props.location.state.item;
        //                 let items = [commessa];
        //                 this.setState({items: items.concat(this.state.items)});
        //             }
        //
        //         }
        //     });
    }

    componentWillUnmount() {
        // Segnalati comportamenti anomali. #2 BUG
        // var state = this.state
        // this.instance.save('commesselist', state);
        if (this.storeInstance) {
            this.storeInstance.save('commesselist', this.state);
        }
    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        if (columnName){
            let newOrderInfo = {
                columnName: columnName,
                direction: direction,
                data: data
            };
            this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo);
        }
        else{
            this.loadData(this.getStartPageByListViewType(), {}, this.state.filterInfo);
        }

    }

    onChangeCommessaStato(isChiusa, isArchiviata){
        let newFilterInfo = {
            keyword: this.state.filterInfo.keyword,
            isChiusa,
            isArchiviata
        };
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo);
    }

    cambiaTipoLista(tipo){
        this.setState({listViewType: tipo}, () => {
            if (tipo === 'r'){
                //Ricarico senza paginazione
                this.loadData(-1, this.state.orderInfo, this.state.filterInfo);
            } else if (this.state.page === -1){
                // Vengo dalla visualzizzazione report, reimposto la pagina a 1
                this.loadData(1, this.state.orderInfo, this.state.filterInfo);
            }
        });
    }

    onChangeFilter(data){
        let newFilterInfo = {
            keyword: data.keyword,
            isChiusa: this.state.filterInfo.isChiusa,
            isArchiviata: this.state.filterInfo.isArchiviata,
        };
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    loadData(page, orderInfo, filterInfo, cb) {
        this.setState({_loading: true});
        client.loadCommesseList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    }, cb)
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onDeleteCommessa(ev, commessa){

        this.setState({_loading: true});
        client.deleteCommessa(commessa).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }



    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Commesse soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                            <CommesseListTypeButton
                                listType={this.state.listViewType}
                                onButtonClick={(t) => {this.cambiaTipoLista(t)}}
                            />
                        </div>
                    </div>
                </div>


            </h3>
            <div className="ui attached segment">
                <div className="ui two column stackable grid">
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra commessa per nome, codice, SDI/IPA o CUP"
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="column">
                        <CommessaStatoSelect
                            isChiusa={this.state.filterInfo.isChiusa}
                            isArchiviata={this.state.filterInfo.isArchiviata}
                            onChange={this.onChangeCommessaStato}
                        />
                    </div>
                </div>

            </div>

            {
                this.state.listViewType === 'l' ?
                    <CommesseTable
                        items={this.state.items}
                        count={this.state.total}
                        page={this.state.page}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onDeleteItem={this.onDeleteCommessa}
                        filterDescription={this.getFilterDescription()}
                        readOnly={client.getCurrentUser().isrolecommessew===false}
                    />
                    :<CommesseReportList items={this.state.items} filterDescription={this.getFilterDescription()}/>
            }

            {loader}
        </div>)
    }
}

CommesseList.contextTypes = {
    router: PropTypes.object
}


export default CommesseList;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseList.js
 **/